import React, { useEffect, useState } from "react";
import { getUser } from "../../utils/types";

interface PermissionActionProps {
    module: string;
    permission: string;
    children: any;
}

const PermissionAction: React.FC<PermissionActionProps> = ({ module, permission, children }) => {
    const [isValid, setIsValid] = useState(false);
    const user: any = getUser() // Get user from localStorgare


    useEffect(() => {

        if (user?.roles?.admin_access === false) {
            if (user?.roles?.permisssions?.length > 0) {
                user?.roles?.permisssions?.forEach((item: any) => {
                    if (item?.slug_name === module) {
                        item?.actions?.forEach((permi: any) => {
                            if (permi === permission) {
                                setIsValid(true)
                            }
                        })
                    }
                })
            }
        } else {
            setIsValid(true)
        }
    }, [])

    return !!isValid ? children : null
}

export default PermissionAction;